<section class="orchestrator-admin">
  <header class="panel-header">
    <h3>SQLite orquestador (jobs)</h3>
    <p>Consulta y edición controlada de la cola interna del orquestador.</p>
  </header>

  <div class="summary-row">
    <span class="chip">Workers activos: {{ activeWorkers }}</span>
    <span class="chip">Procesando: {{ processingJobs }}</span>
    <span class="chip">En cola: {{ pendingJobs }}</span>
    @if (generatedAt) {
      <span class="chip">Actualizado: {{ generatedAt | date:'dd/MM HH:mm:ss' }}</span>
    }
  </div>

  <div class="filters-row">
    <label>
      Estado
      <select [(ngModel)]="stateFilter">
        @for (state of stateOptions; track state) {
          <option [value]="state">{{ state }}</option>
        }
      </select>
    </label>

    <label class="search-label">
      Buscar
      <input
        type="text"
        [(ngModel)]="searchQuery"
        placeholder="video_id, machine_id, s3_path..."
        (keyup.enter)="loadJobs()"
      />
    </label>

    <button (click)="loadJobs()" [disabled]="isLoading">Actualizar</button>
  </div>

  @if (feedbackMessage) {
    <p class="feedback">{{ feedbackMessage }}</p>
  }

  <div class="table-wrapper" [class.loading]="isLoading">
    @if (jobs.length === 0 && !isLoading) {
      <div class="empty-state">No hay jobs para el filtro actual.</div>
    } @else {
      <table>
        <thead>
          <tr>
            <th>Video</th>
            <th>Estado</th>
            <th>Prioridad</th>
            <th>Cola</th>
            <th>Worker</th>
            <th>Preferido</th>
            <th>Reproc.</th>
            <th>Ruta S3</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          @for (job of jobs; track job.video_id) {
            <tr [class.editing]="isEditing(job)">
              <td class="video-cell">
                <span class="video-id">{{ job.video_id }}</span>
                <span class="time">upd {{ job.updated_at | date:'dd/MM HH:mm:ss' }}</span>
              </td>

              <td>
                @if (isEditing(job) && editDraft) {
                  <select [(ngModel)]="editDraft.state">
                    <option value="PENDING">PENDING</option>
                    <option value="PROCESSING">PROCESSING</option>
                    <option value="COMPLETED">COMPLETED</option>
                    <option value="ERROR">ERROR</option>
                    <option value="CANCELLED">CANCELLED</option>
                  </select>
                } @else {
                  <span class="state" [class]="'state-' + (job.state || '').toLowerCase()">{{ job.state }}</span>
                }
              </td>

              <td>
                @if (isEditing(job) && editDraft) {
                  <input type="number" min="0" max="1000" [(ngModel)]="editDraft.priority" />
                } @else {
                  {{ job.priority }}
                }
              </td>

              <td>
                @if (job.queue_type && job.queue_position) {
                  {{ job.queue_type }} · {{ job.queue_position }}
                  @if (job.global_queue_position) {
                    <span class="time"> (global {{ job.global_queue_position }})</span>
                  }
                } @else {
                  -
                }
              </td>

              <td>
                @if (isEditing(job) && editDraft) {
                  <input type="text" [(ngModel)]="editDraft.machine_id" placeholder="machine_id" />
                } @else {
                  {{ job.machine_id || '-' }}
                }
              </td>

              <td>
                @if (isEditing(job) && editDraft) {
                  <input type="text" [(ngModel)]="editDraft.preferred_machine" placeholder="preferred_machine" />
                } @else {
                  {{ job.preferred_machine || '-' }}
                }
              </td>

              <td>
                @if (isEditing(job) && editDraft) {
                  <input type="checkbox" [(ngModel)]="editDraft.reprocess" />
                } @else {
                  {{ job.reprocess ? 'Sí' : 'No' }}
                }
              </td>

              <td class="s3-cell">
                @if (isEditing(job) && editDraft) {
                  <input type="text" [(ngModel)]="editDraft.s3_path" />
                } @else {
                  <span [title]="job.s3_path">{{ job.s3_path }}</span>
                }
              </td>

              <td class="actions-cell">
                @if (isEditing(job)) {
                  <button (click)="saveEdit(job)" [disabled]="isSaving">Guardar</button>
                  <button class="secondary" (click)="cancelEdit()" [disabled]="isSaving">Cancelar</button>
                } @else {
                  <button (click)="startEdit(job)">Editar</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</section>

